import { connect } from "react-redux";
import AdddMediaComponent from "../../Components/Medias/AddMediaComponent";
import { setMedias } from "../../Redux/Actions/MediaActions";

const mapStateToProps = (state) => ({
    MEDIAS: state.reducer.MEDIAS,
    ACTIVE_TENANT: state.reducer.ACTIVE_TENANT,
   
});
const mapDispatchToProps = (dispatch) => ({
  setMedias: (MEDIAS) => dispatch(setMedias(MEDIAS)),
    
});
 
export default connect(mapStateToProps, mapDispatchToProps)(AdddMediaComponent);